import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../axiosInstance';
import './ContactsBanner.css';
import moment from 'moment-timezone';

const API_URL = process.env.REACT_APP_API_URL;

const ContactsBanner = ({ onClose }) => {
  const [currentView, setCurrentView] = useState('search');
  const [searchEmail, setSearchEmail] = useState('');
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${API_URL}/api/contact`);
      setContacts(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error fetching contacts:', error);
      setContacts([]);
    }
    setLoading(false);
  };

  const fetchContactByEmail = async (email) => {
    if (!email) return;
    
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${API_URL}/api/contact`, {
        params: { email }
      });
      
      // Handle array response (backend always returns array)
      const contactData = Array.isArray(response.data) ? response.data[0] : null;
      setSelectedContact(contactData);
    } catch (error) {
      console.error('Error fetching contact:', error);
      setSelectedContact(null);
    }
    setLoading(false);
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleEmailChange = (e) => {
    const email = e.target.value.toLowerCase();
    setSearchEmail(email);
    if (isValidEmail(email)) {
      fetchContactByEmail(email);
    } else {
      setSelectedContact(null);
    }
  };
  

  const handleSearchClick = () => {
    setCurrentView('search');
    fetchContacts();
  };

  const handleViewClick = () => {
    setCurrentView('view');
    setSelectedContact(null);
  };

  useEffect(() => {
    if (currentView === 'search') {
      fetchContacts();
    }
  }, [currentView]);

  return (
    <div className="register-Deliverable">
      <div>
      <button className="close-button" onClick={onClose}>×</button>
      <div className="toggle-buttons">
          <button
            className={`toggle-button ${currentView === 'search' ? 'active' : ''}`}
            onClick={handleSearchClick}
          >
            Search Contacts
          </button>
          <button
            className={`toggle-button ${currentView === 'view' ? 'active' : ''}`}
            onClick={handleViewClick}
          >
            View Contact
          </button>
        </div>

        <div className="popup-content">
          <div className="mini_container">
          
            
            {currentView === 'search' ? (
              <div className="search-contacts">
                {loading ? (
                  <p>Loading...</p>
                ) : contacts.length > 0 ? (
                  <ul>
                    {contacts.map(contact => (
                      <li key={contact._id}>
                        {contact.name} ({contact.email})
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No contacts found</p>
                )}
              </div>
            ) : (
              <div className="view-contact">
                <input
                  type="text"
                  placeholder="Enter email to view contact"
                  value={searchEmail}
                  onChange={handleEmailChange}
                />
              
                {loading ? (
                  <p>Loading...</p>
                ) : selectedContact ? (
                  <div>
                    <p className="contact-name">
                      {selectedContact.name || "No Name Available"}
                    </p>
                    <p className="last-login">
                      <span className="last-login-label"></span>
                      <span
                        className={`last-login-date ${
                          selectedContact.lastLogin &&
                          moment().diff(moment(selectedContact.lastLogin), "hours") <= 24
                            ? "recent-login"
                            : ""
                        }`}
                      >
                        {selectedContact.lastLogin
                          ? moment(selectedContact.lastLogin)
                              .tz("America/New_York")
                              .format("MMMM D, YYYY h:mm:ss A")
                          : "No Last Login Available"}
                      </span>
                    </p>
                  </div>
                ) : (
                  <p>{searchEmail ? "No contact found" : ""}</p>
                )}
              </div>
            )}
          </div>
        </div>

      </div>
      

    </div>
    
  );
};

export default ContactsBanner;